import React from 'react';
import { PageSection } from '../PageSection';
import { FlowSteps } from '../FlowSteps';
import { PRODUCT_NAME, constructionStages, packTopics } from '../../data/salesContent';
export function SolutionSection() {
  return <PageSection labelledBy="solution-title" data-id="element-169" data-mp="1618i2u2fop8m">
      <div className="text-center" data-id="element-170" data-mp="15ycp7k5g0qr1">
        <p className="text-base text-carbon-400 md:text-[17px]" data-id="element-171" data-mp="1a22ao0qtms7u">Por eso creamos:</p>
        <h2 id="solution-title" className="mx-auto mt-2 max-w-2xl text-3xl font-extrabold uppercase leading-[1.05] text-white md:text-[2.5rem]" data-id="element-172" data-mp="dbrss5a41ogm">
          {PRODUCT_NAME}
        </h2>
        <div className="mx-auto mt-4 h-1 w-14 bg-accent-500" aria-hidden="true" data-id="element-173" data-mp="mc7x1gyogzmj" />
        <p className="mx-auto mt-4 max-w-xl text-base font-semibold uppercase leading-snug text-carbon-200" data-id="element-174" data-mp="ma3k69iswqa4">
          El sistema completo para enseñar el proceso constructivo de principio a fin.
        </p>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-carbon-300 md:text-[17px]" data-id="element-175" data-mp="3qolhp1orkery">
          Una colección organizada siguiendo la lógica real de una obra:
        </p>
        <FlowSteps steps={constructionStages} className="mx-auto mt-3 max-w-xl" data-id="element-176" data-mp="32n0q52k0oayx" />
        <p className="mt-4 text-base text-carbon-400" data-id="element-177" data-mp="2xmd28pr34a8x">Desde la lectura de planos hasta el proyecto integrador.</p>
      </div>

      <div className="mt-12 border-t border-carbon-800 pt-10" data-id="element-178" data-mp="2sss2ot9uf87m">
        <h3 className="text-center text-3xl font-extrabold uppercase leading-tight text-white md:text-4xl" data-id="element-179" data-mp="2nv8kjia0ybae">
          Todo lo que necesitás. Un solo sistema.
        </h3>
        <p className="mt-2 text-center font-display text-xl font-bold uppercase tracking-wide text-accent-400 md:text-2xl" data-id="element-180" data-mp="2ev3rye9hphga">
          10 volúmenes completos + 5 bonos prácticos
        </p>
        <p className="mx-auto mt-5 max-w-xl text-center text-base leading-relaxed text-carbon-300 md:text-[17px]" data-id="element-181" data-mp="24xpcagve4wp1">
          {PRODUCT_NAME} reúne contenidos sobre:
        </p>
        <ul className="mt-5 grid gap-2.5 sm:grid-cols-2 md:grid-cols-3" data-id="element-182" data-mp="82jdplpqe2bg">
          {packTopics.map(({
          label,
          icon: Icon
        }) => <li key={label} className="flex items-center gap-2.5 rounded-lg border border-carbon-800 bg-carbon-900 px-3.5 py-3 text-sm font-semibold text-carbon-100" data-id="element-183" data-mp="1xkztza09m72m">
              <Icon className="h-4 w-4 shrink-0 text-accent-400" aria-hidden="true" data-id="element-184" data-mp="1no3j4xmw98uw" />
              {label}
            </li>)}
        </ul>
        <p className="mx-auto mt-6 max-w-xl text-center text-base font-semibold leading-relaxed text-white md:text-[17px]" data-id="element-185" data-mp="1snpxjaegkv5a">
          Todo presentado con una secuencia clara para facilitar la enseñanza y relacionar la teoría con situaciones reales de obra.
        </p>
      </div>
    </PageSection>;
}